import * as React from 'react';

import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import { fm } from 'Components/FormatMessage';

const RelapseSymptomsItem = (relapseSymptoms?: IOwnProps['document']['symptoms']): React.JSX.Element => {
  return (
    <HistoryRowVerticalItem
      header={fm('relapse.symptoms.title')}
      value={
        relapseSymptoms?.length &&
        relapseSymptoms.map((item: string) => <div key={item}>{fm(`${'relapse.symptoms.opts.'}${item}`)}</div>)
      }
    />
  );
};

const RelapseSymptomLevelItem = (relapseSymptomLevels?: IOwnProps['document']['symptomLevel']): React.JSX.Element => {
  return (
    <HistoryRowVerticalItem
      header={fm('relapse.symptomLevel.title')}
      value={
        relapseSymptomLevels?.length &&
        relapseSymptomLevels.map((item: string) => <div key={item}>{fm(`${'relapse.symptomLevel.opts.'}${item}`)}</div>)
      }
    />
  );
};

const RelapseOriginOfInformationItem = (
  originOfInformation?: IOwnProps['document']['originOfInformation'],
): React.JSX.Element => {
  return (
    <HistoryRowVerticalItem
      header={fm('relapse.originOfInformation.title')}
      value={originOfInformation && fm('relapse.originOfInformation.opts.' + originOfInformation)}
    />
  );
};

const RelapseCortisonItem = (wasCortisoneGiven?: IOwnProps['document']['wasCortisoneGiven']): React.JSX.Element => (
  <HistoryRowVerticalItem
    header={fm('relapse.wasCortisoneGiven')}
    value={wasCortisoneGiven && fm('relapse.opts.yesNoUnknown.' + wasCortisoneGiven)}
  />
);

const RelapseCortisonRecordedItem = (
  cortisoneMedicationRecorded?: IOwnProps['document']['cortisoneMedicationRecorded'],
): React.JSX.Element => (
  <HistoryRowVerticalItem
    header={fm('relapse.cortisoneMedicationRecorded')}
    value={cortisoneMedicationRecorded && fm('relapse.opts.yesNoUnknown.' + cortisoneMedicationRecorded)}
  />
);

const RelapsePlasmaItem = (wasPlasmaGiven?: IOwnProps['document']['wasPlasmaGiven']): React.JSX.Element => (
  <HistoryRowVerticalItem
    header={fm('relapse.wasPlasmaGiven')}
    value={wasPlasmaGiven && fm('relapse.opts.yesNoUnknown.' + wasPlasmaGiven)}
  />
);

const RelapseHistoryRowData = ({ document }: IOwnProps): React.JSX.Element => (
  <>
    {RelapseSymptomsItem(document.symptoms)}
    {RelapseSymptomLevelItem(document.symptomLevel)}
    {RelapseOriginOfInformationItem(document.originOfInformation)}
    {RelapseCortisonItem(document.wasCortisoneGiven)}
    {RelapseCortisonRecordedItem(document.cortisoneMedicationRecorded)}
    {RelapsePlasmaItem(document.wasPlasmaGiven)}
  </>
);

interface IOwnProps {
  document: IDocumentWithTypeV2<'relapse'>;
}

export default RelapseHistoryRowData;
